import { Pipe } from '@angular/core';

@Pipe({
  name: 'formatDateFr',
})
export class FormatDateFrPipe {
  transform(value: string): string {
    if (!value) return '';
    const date = new Date(value);
    const options: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    };
    return date.toLocaleDateString('fr-FR', options);
  }
}
